import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

import { i18n } from "../../translate/i18n";
import { Stack } from "@mui/material";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  btnWrapper: {
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

// Unidades -> segundos (o motor conta em segundos no campo "sec")
const UNIT_SEC = { seg: 1, min: 60, hora: 3600 };
const UNIT_LABEL = { seg: "seg", min: "min", hora: "h" };

const FlowBuilderIntervalModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [timerValue, setTimerValue] = useState("");
  const [unit, setUnit] = useState("min");
  const [activeModal, setActiveModal] = useState(false);

  const secToUnitValue = (seconds, u) => {
    const s = Number(seconds) || 0;
    if (!s) return "";
    const div = UNIT_SEC[u] || 60;
    const v = s / div;
    return Number.isInteger(v) ? String(v) : String(parseFloat(v.toFixed(2)));
  };

  const buildIntervalLabel = (value, u) => {
    const n = Number(value) || 0;
    if (!n) return "Intervalo";
    return `Intervalo ${n} ${UNIT_LABEL[u] || "min"}`;
  };

  useEffect(() => {
    if (open === 'edit') {
      // intervalos antigos nao tem "unit" -> assume minutos (comportamento anterior)
      const savedUnit = data?.data?.unit || "min";
      setUnit(savedUnit);
      setTimerValue(secToUnitValue(data?.data?.sec, savedUnit));
      setActiveModal(true);
    } else if (open === 'create') {
      setUnit("min");
      setTimerValue("");
      setActiveModal(true);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = async () => {
    const val = Number(timerValue);

    if (!val || val <= 0) {
      return toast.error('Adicione o valor do intervalo');
    }

    const secondsValue = Math.round(val * (UNIT_SEC[unit] || 60));
    const intervalPayload = {
      sec: secondsValue,
      unit,
      label: buildIntervalLabel(val, unit)
    };
    if (open === 'edit') {
      onUpdate({
        ...data,
        data: {
          ...(data?.data || {}),
          ...intervalPayload
        }
      });
    } else if (open === 'create') {
      onSave(intervalPayload);
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">
          {open === 'create' ? `Adicionar um intervalo ao fluxo` : `Editar intervalo`}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField
                label={'Tempo'}
                name="timer"
                type="number"
                value={timerValue}
                onChange={(e) => setTimerValue(e.target.value)}
                autoFocus
                variant="outlined"
                InputProps={{ inputProps: { min: 0, step: 1 } }}
                margin="dense"
                className={classes.textField}
                style={{ flex: 1 }}
              />
              <TextField
                select
                label="Unidade"
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
                variant="outlined"
                margin="dense"
                style={{ minWidth: 140 }}
              >
                <MenuItem value="seg">Segundos</MenuItem>
                <MenuItem value="min">Minutos</MenuItem>
                <MenuItem value="hora">Horas</MenuItem>
              </TextField>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              startIcon={<CancelIcon />}
              onClick={handleClose}
              style={{
                color: "white",
                backgroundColor: "#db6565",
                boxShadow: "none",
                borderRadius: 0,
                fontSize: "12px",
              }}
              variant="outlined"
            >
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              startIcon={<SaveIcon />}
              type="submit"
              style={{
                color: "white",
                backgroundColor: "#437db5",
                boxShadow: "none",
                borderRadius: 0,
                fontSize: "12px",
              }}
              variant="contained"
              className={classes.btnWrapper}
              onClick={() => handleSaveContact()}
            >
              {open === 'create' ? `Adicionar` : 'Editar'}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderIntervalModal;
